import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { s as srOnlyMixin } from '../theme/style-mixins/srOnly-D3ByQyko.js';

const StyledP = /*#__PURE__*/styled('p').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1qnt3xd-0"
})(["", ";", " padding:0;margin:0;a{text-decoration:underline;}", ""], ({
  theme,
  $size,
  $weight,
  $color
}) => css(["font:", ";", " font-weight:", ";color:", ";"], $size === 'inherit' ? $size : theme.font.text[$size].default, isMobile(css(["font:", ";"], $size === 'inherit' ? $size : theme.font.text[$size].mobile)), $weight === 'inherit' ? 'inherit' : theme.font.weight[$weight], $color === 'inherit' ? 'inherit' : theme.text.color[$color]), ({
  $inline
}) => $inline && 'display: inline;', ({
  theme,
  $withMargin
}) => css(["margin-block-start:", ";margin-block-end:", ";:last-child{margin-block-start:", ";margin-block-end:", ";}"], $withMargin ? theme.text.marginBlockStart.default : 0, $withMargin ? theme.text.marginBlockEnd.default : 0, $withMargin ? theme.text.marginBlockStart.default : 0, $withMargin ? theme.text.marginBlockEnd.default : 0));
StyledP.displayName = 'StyledP';
const StyledSpan = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1qnt3xd-1"
})(["", ";padding:0;margin:0;display:inline;a{text-decoration:underline;}"], ({
  theme,
  $size,
  $weight,
  $color
}) => css(["font:", ";", " font-weight:", ";color:", ";"], $size === 'inherit' ? $size : theme.font.text[$size].default, isMobile(css(["font:", ";"], $size === 'inherit' ? $size : theme.font.text[$size].mobile)), $weight === 'inherit' ? 'inherit' : theme.font.weight[$weight], $color === 'inherit' ? 'inherit' : theme.text.color[$color]));
StyledSpan.displayName = 'StyledSpan';
const StyledScreenReaderOnly = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-40025937__sc-1qnt3xd-2"
})(["", ""], srOnlyMixin);
StyledScreenReaderOnly.displayName = 'StyledScreenReaderOnly';

export { StyledP as S, StyledScreenReaderOnly as a, StyledSpan as b };
//# sourceMappingURL=Text.styles-BjzGbPUi.js.map
